import { migration as initial } from "./001_initial";
import { migration as softDeleteUniqueIndexes } from "./002_soft_delete_unique_indexes";
import { migration as billingPolicySettings } from "./003_billing_policy_settings";
import { migration as accountingReceiptLink } from "./004_accounting_receipt_link";

export const migrations = [initial, softDeleteUniqueIndexes, billingPolicySettings, accountingReceiptLink];
